import type { Transition, Variants } from 'framer-motion'

export const dashboardEase = [0.22, 1, 0.36, 1] as const

const panelTransition: Transition = {
  duration: 0.45,
  ease: dashboardEase,
}

const tabTransition: Transition = {
  duration: 0.32,
  ease: dashboardEase,
}

export const dashboardPanelContainer: Variants = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.07,
      delayChildren: 0.06,
    },
  },
}

export const dashboardPanelItem: Variants = {
  hidden: { opacity: 0, y: 18 },
  show: {
    opacity: 1,
    y: 0,
    transition: panelTransition,
  },
}

export const dashboardTabContent: Variants = {
  hidden: { opacity: 0, y: 14 },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      ...tabTransition,
      staggerChildren: 0.06,
      delayChildren: 0.04,
    },
  },
  exit: {
    opacity: 0,
    y: -10,
    transition: { duration: 0.18, ease: [0.4, 0, 1, 1] },
  },
}

export const dashboardTabSection: Variants = {
  hidden: { opacity: 0, y: 12 },
  show: {
    opacity: 1,
    y: 0,
    transition: panelTransition,
  },
}

export const dashboardKpiGrid: Variants = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.05, delayChildren: 0.02 },
  },
}

export const dashboardKpiItem: Variants = {
  hidden: { opacity: 0, y: 14, scale: 0.98 },
  show: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.4, ease: dashboardEase },
  },
}

/** Barra de abas do dashboard — entrada da esquerda para a direita. */
export const dashboardTabBarContainer: Variants = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.055,
      delayChildren: 0.04,
    },
  },
}

export const dashboardTabBarItem: Variants = {
  hidden: { opacity: 0, x: -14 },
  show: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.32, ease: dashboardEase },
  },
}

export const dashboardReducedVariants = {
  container: { hidden: {}, show: {} } satisfies Variants,
  item: { hidden: {}, show: {} } satisfies Variants,
  tab: { hidden: {}, show: {}, exit: {} } satisfies Variants,
  section: { hidden: {}, show: {} } satisfies Variants,
  kpiGrid: { hidden: {}, show: {} } satisfies Variants,
  kpiItem: { hidden: {}, show: {} } satisfies Variants,
  tabBar: { hidden: {}, show: {} } satisfies Variants,
  tabBarItem: { hidden: {}, show: {} } satisfies Variants,
}

export function getDashboardVariants(reducedMotion: boolean | null) {
  if (reducedMotion) return dashboardReducedVariants
  return {
    container: dashboardPanelContainer,
    item: dashboardPanelItem,
    tab: dashboardTabContent,
    section: dashboardTabSection,
    kpiGrid: dashboardKpiGrid,
    kpiItem: dashboardKpiItem,
    tabBar: dashboardTabBarContainer,
    tabBarItem: dashboardTabBarItem,
  }
}
